<template>
  <el-dialog title="充值中心"
             :visible.sync="dialogFormVisible"
             custom-class="medium-dialog" :append-to-body="true"
             center
             :close-on-click-modal="false"
             :modal="true">
    <el-form :model="form" ref="form1">

      <el-row>
        <el-col :span="24">
          <el-form-item label="客户名称" :label-width="formLabelWidth" prop="customername">
            <el-input v-model="form.customername" auto-complete="off" :required="true" disabled="disabled"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24" hidden="hidden">
          <el-form-item label="客户编码" :label-width="formLabelWidth" prop="customerserial">
            <el-input v-model="form.customerserial" auto-complete="off" :required="true" readonly></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="false">
        <el-col>
          <el-form-item label="充值/退款方式" :label-width="formLabelWidth">
            <el-select v-model="style" placeholder="请选择" @change="change">
              <el-option
                v-for="item in styleArray"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24" v-if="debitFlag">
          <el-form-item label="充值金额" :label-width="formLabelWidth" prop="debit">
            <el-input-number v-model="form.debit" auto-complete="off" :required="true" :controls="false" ></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
      <el-col :span="24" >
        <el-form-item label="充值方式" :label-width="formLabelWidth" v-if="debitFlag">
          <el-select v-model="form.rechargeserial" placeholder="请选择" filterable :clearable="true" >
            <el-option
              v-for="item in buyhetongseriallist"
              :key="item.name"
              :label="item.name"
              :value="item.name">
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      </el-row>
      <el-row>
        <el-col :span="24" v-if="creditFlag">
          <el-form-item label="退款金额" :label-width="formLabelWidth" prop="credit">
            <el-input v-model="form.credit" auto-complete="off" :required="true"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24">
          <el-form-item label="备注" :label-width="formLabelWidth" prop="remark">
            <el-input v-model="form.remark" auto-complete="off"
                      :required="true"
                      type="textarea"
                      :autosize="{ minRows: 3, maxRows: 4}"
                      placeholder="请输入内容"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row v-if="simpleedit">
        <el-col :span="24">
          <el-collapse v-model="activeNames">
          <el-collapse-item name="1">
            <template slot="title" style="display: inline-block;">
        <span class="titlecolor">充值日志</span>
            </template>
              <div class="search-content">
                <el-col :span="24" class="toobar">
                  <el-col :span="18">
                    <span class="demonstration">日期</span>
                    <el-date-picker style="width:140px" size="mini"
                                    v-model="beginDate" :value-format="'yyyy-MM-dd'"
                                    type="date"
                                    placeholder="选择日期"
                    >
                    </el-date-picker>
                    <span class="demonstration">至</span>
                    <el-date-picker style="width:140px" size="mini"
                                    v-model="endDate" :value-format="'yyyy-MM-dd'"
                                    type="date"
                                    placeholder="选择日期">
                    </el-date-picker>
                  </el-col>
                  <el-col :span="6">
                    <el-button type="warning" icon="el-icon-search" @click="rechargelog(1)" size="mini">搜索</el-button>
                    <el-button type="warning" icon="el-icon-download" @click="rechargelog(2)" size="mini">导出</el-button>
                  </el-col>
                </el-col>
              </div>
              <el-col :span="24">
                <el-table
                  :data="tablelogData"
                  size="mini"
                  stripe
                  border
                  style="width: 100%;">
                  <el-table-column
                    width="60"
                    label="序号" fixed
                    align="center">
                    <template slot-scope="scope">
                      {{1+scope.$index+(pagination.currentPage-1)*pagination.pageSize}}
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="adddate"
                    label="日期"
                    align="center"
                    header-align="center"
                    width="140">
                  </el-table-column>
                  <el-table-column
                    prop="customername"
                    label="客户名称"
                    align="left"
                    header-align="center"  width="250" :show-overflow-tooltip="true">
                  </el-table-column>
                  <el-table-column
                    prop="debit"
                    label="金额"
                    align="right"
                    header-align="center"
                    width="100">
                    <template slot-scope="scope">
                      {{scope.row.debit|numeric(2)}}{{scope.row.credit|numeric(2)}}
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="rechargeserial"
                    label="方式"
                    align="left"
                    header-align="center" :show-overflow-tooltip="true"
                    width="100">
                  </el-table-column>
                  <el-table-column
                    prop="applyby"
                    label="录入人"
                    align="center" :show-overflow-tooltip="true"
                    header-align="center"
                    width="95">
                  </el-table-column>
                  <el-table-column
                    prop="remark" width="200"
                    label="摘要"
                    align="left"
                    header-align="center" :show-overflow-tooltip="true">
                  </el-table-column>
                </el-table>
              </el-col>
              <el-col :span="24">
                <el-col :span="18">
                  <Pagination ref="pagination1" @bindgrid="rechargelog(false)" :pagination="pagination"></Pagination>
                </el-col>
                <el-col :span="6">
                  <!--合计： {{totalmoney}}-->
                </el-col>
              </el-col>
          </el-collapse-item>
          </el-collapse>
        </el-col>
      </el-row>

    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="saveData" :disabled="isDisable">保 存</el-button>
    </div>
  </el-dialog>
</template>
<script>
  import {saveData,getListData} from '@/api/set/recharge';
  import {getListData as bankList} from '@/api/set/PriceandKd';
  import {getNowFormatDate, getPreMonth} from '@/api/dateUtil';


  export default {
    name: "rechargeRecordAdd",
    data() {
      return {
        dialogFormVisible: false,
        isDisable: false,
        debitFlag: true,
        creditFlag: false,
        style: "充值",
        buyhetongseriallist:[],
        activeNames: ['1'],
        beginDate:'',
        endDate:'',
        tablelogData:[],
        form: {  //表单数据
          customername: "",
          customerserial: "",
          rechargeserial:"",
          debit: undefined,
          remark: "",
          credit: ''
        },
        pagination: {
          currentPage: 1,
          pageSize: 100,
          total: 0
        },
        formLabelWidth: '120px',
        styleArray: [{
          value: '充值',
          label: '充值'
        }, {
          value: '退款',
          label: '退款'
        }]
      }
    },
    props:{
      simpleedit:false,
    },
    methods: {
      rechargelog(loadexcel){
        var excels=loadexcel==2;
        if (!this.beginDate) {
          let beginDate = getNowFormatDate();
          this.endDate = beginDate;
          this.beginDate = beginDate;
        }
        var row={
          customerserial: '',
          beginDate: this.beginDate,
          endDate: this.endDate,
          paymentType: '',
          recordType: 1,
          applybyguid: JSON.parse(localStorage.getItem("hpapi_userInfoModel")).uguid,
          servedserial: 'all',
        };
        if(!excels) {
          row.offset = (this.pagination.currentPage - 1) * this.pagination.pageSize;
          row.limit = this.pagination.pageSize;
        }
        getListData(row).then(response=>{
          if(excels){
            var tabledata = response.data.obj
            var date = new Date();
            var y = 1900 + date.getYear();
            var m = "0" + (date.getMonth() + 1);
            var d = "0" + date.getDate();
            let header1 = ["时间", "金额","方式", "客户编码", "客户", "充值方式", "经办人", "备注"]
            let column1 = ["adddate","debit","rechargeserial", "customerserial", "customername", "rechargeserial", "applyby", "remark"]
            var name = '充值信息' + y + m.substring(m.length - 2, m.length) + d.substring(d.length - 2, d.length)
            this.$exportExcel(header1, column1, tabledata, name)
          }else{
            this.tablelogData = response.data.obj.rows;
            this.pagination.total = response.data.obj.total;
          }
        });
      },
      //收款银行
      buyhetongserial() {
        this.buyhetongseriallist=[]
        bankList({
            offset: 0,
            limit: 10000,
            paraname: '收款银行',
          }
        ).then(response => {
          var tabledata = response.data.obj

          for (let i = 0; i < tabledata.length; i++) {
            var obj = {name: '', value: ''}
            obj.name = tabledata[i].name
            obj.value = tabledata[i].unitguid
            this.buyhetongseriallist.push(obj)
          }
        }).catch((error) => {
          console.log(error)
        });
      },
      change() {
        if ("充值" == this.style) {
          this.debitFlag = true;
          this.creditFlag = false;
        } else if ("退款" == this.style) {
          this.creditFlag = true;
          this.debitFlag = false;
        }
        this.form.credit = '';
        this.form.debit = '';
      },
      show(customerSerial, customerName) {
        this.form.customername = customerName;
        this.form.customerserial = customerSerial;
        this.form.debit = undefined;
        this.form.remark = "";
        this.style = "";
        this.dialogFormVisible = true;
        this.buyhetongserial();
        if (this.simpleedit) {
          this.rechargelog(false);
        }
      },
      saveData() {
        let count = "";
        // if (this.style == "充值") {
        //   count = this.form.debit;
        // } else {
        //   count = this.form.credit;
        // }
        count = parseInt(this.form.debit);
        if (Number.isNaN(count)) {
          this.$message({
            message: "请正确输入金额！",
            type: 'error'
          })
          return;
        }
        if(this.buyhetongseriallist.length>0){
          if(!this.form.rechargeserial){
            this.$message({
              message: "充值方式必选！",
              type: 'error'
            })
            return;
          }
        }
        // if (count <= 0) {
        //   this.$message({
        //     message: "充值金额必须大于0",
        //     type: 'error'
        //   })
        //   return;
        // }
        if (this.style == "退款") {
          count = "-" + count;
        }
        this.$refs.form1.validate((valid) => {
          if (valid) {
            saveData(this.form).then(response => {
              if (response.data.code === 0) {
                this.$message({
                  message: '保存成功',
                  type: 'success'
                })
                this.dialogFormVisible = false;
                //刷新列表
                this.$emit('bindGrid');
              } else {
                this.$message({
                  message: response.data.msg,
                  type: 'error'
                })
              }
              this.isDisable = false;
            });
          }
        })
      },
      initForm() {
        this.debitFlag = true;
        this.creditFlag = false;

      },
    },
    mounted() {
      let beginDate = getNowFormatDate();
      this.endDate = beginDate;
      this.beginDate = beginDate;
    },
    components: {}
  }
</script>





// WEBPACK FOOTER //
// src/components/set/recharge/rechargeRecordAdd.vue